<template>
  <div class="container">
    <!-- 搜索框 -->
    <!-- <searchBox></searchBox> -->
    <search-box frompage="首頁" />
    <!-- 置顶文章 -->
    <div
      v-if="showTop"
      class="mes-box"
    >
      <div class="mes-left-box">
        <div class="mes-leftit-box">
          {{ topMes.titleNameWithCulture }}
        </div>
        <div class="mes-leftcon-box">
          <span>{{ topMes.contentFilterHTMLWithCulture.slice(0, 200) }}</span>
          <span v-if="topMes.contentFilterHTMLWithCulture.length > 200">...</span>
          <div
            class="mes-leftcon-more"
            @click="readMore(topMes.questionId,topMes.titleNameWithCulture)"
          >
            閱讀更多 >
          </div>
        </div>
      </div>

      <div class="mes-right-box">
        <template v-if="topMes.videoPath && topMes.videoPath.indexOf('www.youtube.com') == -1">
          <video
            width="100%"
            height="320px"
            :src="topMes.videoPath"
            controls
          >
            <h2>我們很抱歉，您的瀏覽器<strong>不支持video標籤</strong></h2>
            <a href="https://www.google.cn/chrome/">點擊這裡下載瀏覽器</a>
          </video>
        </template>
        <template v-if="topMes.videoPath && topMes.videoPath.indexOf('www.youtube.com') > -1">
          <iframe
            id="ifrId"
            :src="topMes.videoPath"
            frameborder="0"
            width="100%"
            height="320px"
          />
        </template>
        <template v-else>
          <img
            v-if="topMes.imagePath"
            :src="topMes.imagePath"
            alt=""
            @click="goMainBody(topMes.questionId)"
          >
        </template>
      </div>
    </div>
    <!-- 常见问题 -->
    <div class="que-box">
      <div>
        <img
          src="../../../assets/helpQue.png"
          alt=""
        >
        <span class="que-box-tit">常見問題</span>
      </div>
      <div class="que-box-flex">
        <div
          v-for="(item, index) in commonQue"
          :key="index"
          class="que-box-con"
        >
          <img
            src="../../../assets/helpQuelig.png"
            alt=""
          >
          <span class="que-tit-con">{{ item.titleNameWithCulture }}</span>
          <div class="que-box-mid">
            {{ item.contentFilterHTMLWithCulture }}
          </div>
          <div
            class="que-box-bot"
            @click="goMainBody(item.id,item.titleNameWithCulture,'commonque')"
          >
            查看更多 >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from './searchBox.vue';

export default {
    components: {
        SearchBox
    },
    data() {
        return {
            selCon: '',
            showTop:true,
            topMes: {
                titleNameWithCulture: '',
                contentFilterHTMLWithCulture: '',
                imagePath: '',
                videoPath: ''
            },
            commonQue: []
        };
    },
    created() {
        this.$store.commit('changeSelectLi', 0);
        // 获取置顶文章
        this.gettopquestion();
        this.getcommonquestions();
    },
    methods: {
        goMainBody(id,titleNameWithCulture,type) {
            this.$store.commit('changefrompage','幫助中心首頁');
            if(type == 'commonque'){
                gio('track', 'element_click', {
                    channel: '幫助中心',
                    location: `幫助中心首頁_${titleNameWithCulture}`,
                    element_content: titleNameWithCulture,
                    element_link: `/helpcenter/mainbody?questionId=${id}`,
                    element_name: titleNameWithCulture,
                    page: `幫助中心首頁`,
                    platform: 'web'
                });
                gio('evar.set', {
                    evar_ad_position: `幫助中心首頁_${titleNameWithCulture}`,
                    evar_page: '幫助中心首頁'
                });
            }
            this.$router.push({ path: '/helpcenter/mainbody', query: { questionId: id } });
            let arr = [];
            if (JSON.parse(localStorage.getItem('questionId'))) {
                arr = JSON.parse(localStorage.getItem('questionId'));
            } else {
                arr = [];
            }
            arr = [...new Set(arr)]
            arr.unshift(id);
            if (arr.length > 5) {
                arr.pop();
            }
            localStorage.setItem('questionId', JSON.stringify(arr));
            // this.$router.push({ name: this.pub.routeNameLists.MainBody,params:{'questionId':id}});
        },
        readMore(id,titleNameWithCulture) {
            this.$store.commit('changefrompage','幫助中心首頁');
            gio('track', 'element_click', {
                channel: '幫助中心',
                location: `幫助中心首頁_${titleNameWithCulture}`,
                element_content: titleNameWithCulture,
                element_link: `/helpcenter/mainbody?questionId=${id}`,
                element_name: titleNameWithCulture,
                page: `幫助中心首頁`,
                platform: 'web'
            });
            gio('evar.set', {
                evar_ad_position: `幫助中心首頁_${titleNameWithCulture}`,
                evar_page: '幫助中心首頁'
            });
            this.$store.commit('changeSelectLi', '');
            this.$router.push({ path: '/helpcenter/mainbody', query: { questionId: id } });
            let arr = [];
            if (JSON.parse(localStorage.getItem('questionId'))) {
                arr = JSON.parse(localStorage.getItem('questionId'));
            } else {
                arr = [];
            }
            arr = [...new Set(arr)]
            arr.unshift(id);
            if (arr.length > 5) {
                arr.pop();
            }
            localStorage.setItem('questionId', JSON.stringify(arr));
        },
        gettopquestion() {
            this.axios.get(this.pub.getApi().GetTopQuestions).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    let { result } = res.data;
                    this.topMes.contentFilterHTMLWithCulture = result.contentFilterHTMLWithCulture;
                    this.topMes.imagePath = result.imagePath;
                    this.topMes.titleNameWithCulture = result.titleNameWithCulture;
                    this.topMes.questionId = result.id;
                    if(result.videoPath.indexOf('www.youtube.com')>-1){
                        let tmpurl = result.videoPath.replace('https:','')
                        tmpurl = tmpurl.replace('watch?v=','embed/')+'?wmode=transparent';
                        this.topMes.videoPath = tmpurl
                    }else{
                        this.topMes.videoPath = result.videoPath;
                    }
                }else{
                    this.showTop = false
                }
            });
        },
        getcommonquestions() {
            this.axios.get(this.pub.getApi().GetCommonQuestions, { params: { count: 20 } }).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.commonQue = res.data.result.slice(0, 6);
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.container {
    padding-left: 20px;
    padding-right: 20px;
    background-color: #f3f3f5;
    .search-box {
        text-align: left;
        .w120 {
            width: 45%;
            height: 46px;
            margin-right: 15px;
        }
        /deep/ .el-input--suffix .el-input__inner {
            border-radius: 11px;
            height: 46px;
        }
    }
    .mes-box {
        width: 1126px;
        min-height: 320px;
        margin-top: 30px;
        border-radius: 15px;
        background-color: #fff;
        padding: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .mes-left-box {
            display: inline-block;
            text-align: left;
            width: 600px;
            vertical-align: top;
            .mes-leftit-box {
                font-size: 24px;
                color: #444444;
                font-weight: 700;
            }
            .mes-leftcon-box {
                font-size: 14px;
                color: #7f7f7f;
                margin-top: 20px;
                .mes-leftcon-more {
                    color: #0062ff;
                    font-size: 14px;
                    cursor: pointer;
                    margin-top :20px;
                    width:75px;
                }
                .mes-leftcon-more:hover{
                    text-decoration: underline;
                }
                span{
                    color: #444444;
                }
            }
        }
        .mes-right-box {
            display: inline-block;
            min-width: 500px;
            max-width: 46%;
            img {
                width: 100%;
                height: 320px;
                cursor: pointer;
            }
            div {
                width: 100%;
                min-height: 300px;
            }
        }
    }
    .que-box {
        // height: 300px;
        width: 1126px;
        margin-top: 30px;
        border-radius: 15px;
        background-color: #fff;
        text-align: left;
        padding: 20px;
        .que-box-flex {
            width: 100%;
            margin-top: 25px;
            .que-box-con {
                width: 350px;
                margin-right: 24px;
                display: inline-block;
                margin-bottom: 50px;
                img {
                    width: 20px;
                    height: 20px;
                    vertical-align: text-bottom;
                }
                .que-tit-con {
                    font-size: 18px;
                    color: #444444;
                    margin-left: 5px;
                    font-weight: 700;
                }
                .que-box-mid {
                    min-height: 42px;
                    font-size: 16px;
                    color: #44444f;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    margin: 12px 0;
                }
                .que-box-bot {
                    font-size: 16px;
                    color: #0062ff;
                    cursor: pointer;
                }
                .que-box-bot:hover{
                    text-decoration:underline;
                }
            }
        }
        .que-box-tit {
            font-size: 24px;
            color: #444444;
            font-weight: 700;
            margin-left: 8px;
        }
        img {
            width: 20px;
            height: 20px;
        }
    }
}
</style>
